import React from 'react';
import { Section } from './ui/Section';
import { GoldButton } from './ui/GoldButton';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <>
      {/* Hero image - person in bed, dim light */}
      <div className="relative w-full h-[60vh] md:h-[70vh] overflow-hidden" data-id="element-93">
        <motion.img src="https://cdn.magicpatterns.com/uploads/pD584mqSTk6zwBTs6io7KG/foto1-sales_letter.png" alt="Mujer despierta en la cama sin poder dormir, luz tenue de mesita de noche" className="absolute inset-0 w-full h-full object-cover object-center" initial={{
        opacity: 0,
        scale: 1.05
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} data-id="element-94" />
        {/* Dark overlay for mood */}
        <div className="absolute inset-0 bg-[#1a2332]/60" data-id="element-95" />
        {/* Bottom gradient fade into page background */}
        <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-[#1a2332] to-transparent" data-id="element-96" />

        {/* Top claim text */}
        <motion.p className="absolute top-8 md:top-12 left-0 right-0 text-center text-2xl md:text-4xl lg:text-5xl font-serif text-[#c9a04e] px-6 z-10 drop-shadow-lg" initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.5
      }} data-id="element-97">
          No duermes por las noches...
        </motion.p>
      </div>

      <Section className="pt-12 md:pt-16 pb-20" data-id="element-98">
        <div className="space-y-12 text-center md:text-left" data-id="element-99">
          <h1 className="text-4xl md:text-5xl lg:text-6xl leading-tight text-[#f5f0e8]" data-id="element-100">
            Si tu cuerpo tiene sueño pero tu mente no,{' '}
            <span className="text-[#c9a04e]" data-id="element-101">esto es para ti.</span>
          </h1>

          <div className="space-y-6 text-lg md:text-xl text-[#f5f0e8]/90 leading-relaxed font-light" data-id="element-102">
            <p data-id="element-103">Te acuestas cansada.</p>
            <p data-id="element-104">Cansada de verdad.</p>
            <p data-id="element-105">Apagas la luz…</p>
            <p data-id="element-106">y justo ahí empieza el turno de noche de tu cabeza.</p>

            <div className="py-4 space-y-4 text-[#8a9bb0]" data-id="element-107">
              <p data-id="element-108">Te recuerda lo que no hiciste.</p>
              <p data-id="element-109">Lo que dijiste raro.</p>
              <p data-id="element-110">Lo que puede salir mal mañana.</p>
              <p data-id="element-111">Lo que "deberías" estar controlando.</p>
            </div>

            <p data-id="element-112">Y tú, agotada, intentas negociar.</p>
            <p className="italic text-[#8a9bb0]" data-id="element-113">"Si me duermo ya…"</p>
            <p className="italic text-[#8a9bb0]" data-id="element-114">
              "Si no me duermo en 10 minutos…"
            </p>
            <p className="italic text-[#8a9bb0]" data-id="element-115">"¿Y si mañana estoy fatal?"</p>

            <p data-id="element-116">Pero cuanto más intentas dormir, menos pasa.</p>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="py-8 text-center" data-id="element-117">
            <p className="text-2xl md:text-3xl font-serif text-[#c9a04e] border-y border-[#c9a04e]/30 py-6 inline-block" data-id="element-118">
              No te falta sueño. Te falta cierre.
            </p>
          </motion.div>

          <div className="relative group perspective-1000" data-id="element-119">
            <motion.img src="https://cdn.magicpatterns.com/uploads/qEprePVn5oeoDzyRQRpRPr/Apaga_la_cabeza_2.png" alt="Kit Apaga la Cabeza en una mesita de noche" className="w-full rounded-lg shadow-2xl shadow-black/50 opacity-90 hover:opacity-100 transition-opacity duration-700" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1
          }} data-id="element-120" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1a2332] via-transparent to-transparent opacity-20 pointer-events-none" data-id="element-121"></div>
          </div>

          <div className="space-y-6 text-center" data-id="element-122">
            <p className="text-xl leading-relaxed" data-id="element-123">
              <strong className="text-[#c9a04e]" data-id="element-124">Apaga la Cabeza</strong> es un
              kit imprimible de 7 noches para convertir la hora de dormir en un
              protocolo simple:
            </p>
            <p className="text-lg font-medium tracking-wide" data-id="element-125">
              Descargar → bajar el cuerpo → cerrar el bucle.
            </p>
            <p className="text-[#8a9bb0] text-sm uppercase tracking-widest pt-2" data-id="element-126">
              Sin promesas mágicas. Sin teoría eterna. Sin depender de
              motivación.
            </p>

            <div className="pt-8" data-id="element-127">
              <GoldButton href="#oferta" data-id="element-128">
                Quiero el Kit Apaga la Cabeza
              </GoldButton>
            </div>
          </div>
        </div>
      </Section>
    </>;
}